<template>
  <div class="page-wrapper">
    <!-- <Header /> -->
    <!-- <FlashMessage v-if="this.messages.text != ''" :message="this.messages" /> -->

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="flex flex-col lg:flex-row justify-between items-center gap-8 rounded-3xl shadow-xl my-20 h-full"
        >
          <div
            class="lg:px-20 flex flex-col py-14 gap-10 justify-between h-full lg:text-left px-10"
          >
            <h1 class="font-bold text-xl lg:text-3xl prime">
              Welcome Student 
              <span class="text-[#105C8E] text-xl lg:text-3xl ml-2 lg:ml-5">
              </span>
            </h1>

            <p class="content max-w-sm">
              Welcome to your {{ logotitle }} Online Learning Management System
              – your gateway to seamless learning and academic success! Stay
              curious, stay committed, and make the most of every learning
              opportunity.
            </p>

            <div class="flex flex-row items-center">
              <button
                class="bg-[#0F172A] w-40 h-10 rounded-md text-white mx-auto lg:mx-0"
              >
                <router-link :to="{ name: 'PreviewMyCourse' }">
                  Start Learning</router-link
                >
              </button>
            </div>
          </div>

          <div
            class="flex justify-center lg:justify-end gap-4 relative heightfull"
          >
            <img
              src="@/assets/new/index.jpeg"
              alt=""
              class="max-w-full h-auto rounded-r-3xl object-contain heightfull"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="py-3 pb-20">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 shadow-xl rounded-3xl p-4"
          style="box-shadow: 0px 2px 20px 0px #105c8e26"
        >
          <!-- calender -->
          <div class="flex flex-col md:min-w-[330px]">
            <!-- <h1 class="text-[#0F172A] text-lg font-semibold px-6 pt-6">Calendar</h1> -->
            <div class="flex flex-col gap-3 md:min-w-[330px]">
              <Calendar @addFilterEmit="receiveCalEmit" />
              <!-- <vue-cal
                small
                ref="vuecal"
                events-on-month-view="short"
                :disable-views="['years', 'year', 'week', 'day']"
                :events="values"
                :on-event-click="onEventClick"
                class=""
              >
              </vue-cal> -->
            </div>
          </div>
          <!-- <pre>{{ submittedURL }}</pre> -->
          <!-- todo -->
          <div class="flex flex-col">
            <div class="space-y-3 mb-3">
              <div
                v-for="item in submittedURL"
                :key="item.id"
                class="flex justify-between items-center bg-[#EDF8FF] py-3 px-4 rounded-xl"
              >
                <div>
                  <a
                    :href="item.urllink"
                    target="_blank"
                    class="text-[#0085DB] font-semibold hover:underline hover:text-[#006bb3] transition cursor-pointer"
                  >
                    {{ item.title }}
                  </a>
                </div>
              </div>
            </div>

            <div v-if="submitted.length > 0">
              <div v-for="(item, index) in submitted" :key="index" class="pb-3">
                <div
                  class="flex justify-between items-center bg-sky-50 hover:bg-sky-100 border border-sky-100 p-3 rounded-2xl transition duration-200 ease-in-out"
                >
                  <h1
                    class="text-sky-700 text-sm md:text-base font-medium leading-snug w-[90%]"
                  >
                    {{ item.title }}
                  </h1>
                  <a :href="item.pdf" download target="_blank">
                    <svg
                      class="cursor-pointer w-6 h-6 fill-sky-600 hover:fill-sky-800 transition duration-200"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 -960 960 960"
                    >
                      <path
                        d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
                      />
                    </svg>
                  </a>
                </div>

                <p
                  class="truncate w-full flex items-center justify-between bg-gray-100 p-2 rounded mt-2 hidden"
                >
                  {{ getShortName(item.pdf) }}
                </p>
              </div>
              <!-- <div>
                <div
                  class="flex items-center justify-between w-full bg-gray-100 p-2 rounded mt-2"
                >
                  
                </div>
              </div> -->
            </div>
            <!-- <div v-else>No Data Found</div> -->

            <div class="flex flex-col gap-3 md:min-w-[330px]">
              <div
                class="bg-[#EDF8FF] flex justify-between py-2 px-3 rounded-xl items-center"
              >
                <h1 class="text-[#0085DB] text-lg font-semibold">
                  Tasks for Today
                </h1>
                <router-link :to="{ name: 'StudentTaskList' }">
                  <img
                    src="@/assets/chevron-down.png"
                    alt=""
                    srcset=""
                    class="object-contain w-5 h-5"
                  />
                </router-link>
              </div>
              <div class="flex flex-col gap-2 justify-start p-6 h-[330px]">
                <form @submit.prevent="addTask">
                  <div class="flex flex-col gap-2">
                    <p
                      v-if="success_message"
                      class="text-xs text-green-400 font-bold"
                    >
                      {{ success_message }}
                    </p>
                    <p
                      v-if="success_delemessage"
                      class="text-xs text-red-400 font-bold"
                    >
                      {{ success_delemessage }}
                    </p>

                    <div class="">
                      <input
                        v-model="newTask"
                        type="text"
                        class="border-b outline-none flex-1 p-1 w-full"
                        placeholder="+Add New Task"
                        @input="showButton = newTask.length > 0"
                        @keyup.enter="addTask"
                      />
                    </div>
                    <div
                      v-show="showButton"
                      class="flex justify-end items-center"
                    >
                      <div class="flex gap-1">
                        <button
                          class="text-white rounded transition-opacity cursor-pointer"
                        >
                          <img
                            src="@/assets/newd/Vector(1).svg"
                            alt=""
                            srcset=""
                            class="w-5 h-5 bg-[#EBEBEB] p-1"
                          />
                        </button>
                        <div @click="cleartask" class="cursor-pointer">
                          <img
                            src="@/assets/newd/closebutton.svg"
                            alt=""
                            class="w-6 h-6"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <ul class="overflow-y-auto" v-if="todolist.length > 0">
                  <li
                    v-for="task in todolist"
                    :key="task.id"
                    class="group py-2"
                  >
                    <div
                      class="flex justify-between bg-[#F4F4F4] w-full p-2 rounded-md"
                      v-if="task.completed == false"
                    >
                      <p class="text-sm break-words w-[230px] line-clamp-2">
                        {{ task.text }}
                      </p>
                      <div
                        class="flex gap-2 w-[25%] opacity-100 xl:opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                      >
                        <!-- <button @click="completeTask(task.id)" class="">✅</button> -->
                        <button @click="completeTask(task.id)" class="">
                          <img
                            src="@/assets/newd/Vector(1).svg"
                            alt=""
                            srcset=""
                            class="w-6 h-6 bg-[#EBEBEB] p-1"
                          />
                        </button>

                        <button @click="openEditPopup(task)" class="">
                          <img
                            src="@/assets/newd/Group.svg"
                            alt=""
                            srcset=""
                            class="w-6 h-6 bg-[#EBEBEB] p-1"
                          />
                        </button>
                        <button @click="deleteTask(task.id)" class="">
                          <img
                            src="@/assets/newd/Vector.svg"
                            alt=""
                            srcset=""
                            class="w-6 h-6 bg-[#EBEBEB] p-1"
                          />
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>

                <div v-else class="text-center">No task</div>
                <!-- Edit Popup -->
                <!-- <div
                v-if="isEditing"
                class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
              >
                <div class="bg-white p-4 rounded shadow-lg">
                  <h3 class="mb-2">Edit Task</h3>
                  <input
                    v-model="editTaskText"
                    type="text"
                    class="border p-1 w-full"
                  />
                  <div class="flex justify-end mt-2">
                    <button
                      @click="updateTask"
                      class="bg-blue-500 text-white px-2 py-1 rounded mr-2"
                    >
                      Update
                    </button>
                    <button
                      @click="isEditing = false"
                      class="bg-gray-500 text-white px-2 py-1 rounded"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div> -->
                <div
                  v-if="isEditing"
                  class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
                >
                  <div
                    class="w-[90%] lg:w-[40%] bg-white rounded-xl p-6 lg:p-10 overflow-y-auto max-h-[600px]"
                  >
                    <div class="flex items-center justify-center">
                      <h3 class="text-xl font-bold text-textblues text-center">
                        Edit Task
                      </h3>
                    </div>

                    <div
                      class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
                    >
                      <div class="w-full">
                        <form
                          ref="createTeamRef"
                          @submit.prevent="updateTask()"
                          class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                        >
                          <div>
                            <textarea
                              v-model="editTaskText"
                              name=""
                              id=""
                              cols="30"
                              rows="5"
                              class="border p-1 w-full"
                            ></textarea>
                          </div>

                          <div class="flex justify-center pb-4 mt-3 gap-10">
                            <button
                              @click="isEditing = false"
                              class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                            >
                              Close
                            </button>
                            <button
                              class="border text-white rounded-lg bg-blues text-sm px-5 lg:px-10 font-semibold py-2"
                            >
                              Update
                            </button>
                          </div>

                          <div
                            v-if="editmessages"
                            class="text-green-400 text-lg font-bold"
                          >
                            {{ editmessages }}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="" v-for="todo in [0, 1, 2, 3]" :key="todo">
                <div
                  class="flex justify-center gap-4 bg-[#105C8E1A] p-4 rounded-lg items-center"
                >
                  <img
                    src="@/assets/Vector(11).png"
                    alt=""
                    srcset=""
                    class="object contain w-4 h-4 mt-1"
                  />
                  <div class="flex flex-col gap-1">
                    <p class="text-sm font-bold text-[#333333] text-wrap">
                      15 Assignments Due
                    </p>
                  </div>
                </div>
              </div> -->
              </div>
            </div>
          </div>
          <!-- <pre>{{ taskList }}</pre> -->
          <!-- Announcements -->
          <div class="flex flex-col gap-3 md:min-w-[330px]">
            <div
              class="bg-[#EDF8FF] flex justify-between py-2 px-3 rounded-xl items-center"
            >
              <h1 class="text-[#0085DB] text-lg font-semibold">
                Announcements
              </h1>
              <router-link
                :to="{ name: 'StudentNotifications' }"
                v-if="hasAnnouncements"
              >
                <img
                  src="@/assets/chevron-down.png"
                  alt=""
                  srcset=""
                  class="object-contain w-5 h-5"
                />
              </router-link>
            </div>

            <div class="p-6 w-full h-[330px] overflow-y-auto">
              <!-- Check if there's any data to display -->
              <div v-if="hasAnnouncements" class="flex flex-col gap-5">
                <!-- Notifications Section -->
                <div v-if="notificationList.length > 0">
                  <h2 class="text-sm font-bold text-[#0F172A] mb-3">
                    Notifications
                  </h2>
                  <div class="flex flex-col gap-3">
                    <div
                      class="border-b pb-3 border-gray-300 last:border-b-0"
                      v-for="notifi in notificationList.slice(0, 3)"
                      :key="'notif-' + notifi.id"
                    >
                      <div class="flex gap-3">
                        <img
                          src="@/assets/Group 610.png"
                          alt=""
                          class="object-contain w-6 h-6 mt-1 flex-shrink-0"
                        />
                        <div class="flex flex-col gap-1 flex-1 min-w-0">
                          <h3
                            class="text-sm font-semibold text-black break-words line-clamp-2"
                          >
                            {{ notifi.topic }}
                          </h3>
                          <p
                            class="text-xs text-[#ADADAD] break-words line-clamp-2"
                          >
                            {{ notifi.message }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accepted Assignments Section -->
                <div
                  v-if="
                    taskList.accepted_assignments &&
                    taskList.accepted_assignments.length > 0
                  "
                >
                  <h2 class="text-sm font-bold text-green-600 mb-3">
                    Accepted Assignments
                  </h2>
                  <div class="flex flex-col gap-3">
                    <div
                      class="border-b pb-3 border-gray-300 last:border-b-0"
                      v-for="assignment in taskList.accepted_assignments"
                      :key="'accepted-' + assignment.id"
                    >
                      <div class="flex gap-3">
                        <img
                          src="@/assets/Group 610.png"
                          alt=""
                          class="object-contain w-6 h-6 mt-1 flex-shrink-0"
                        />
                        <div class="flex flex-col gap-1 flex-1 min-w-0">
                          <router-link
                            :to="`/student/dashboard/${assignment.course_id}/assignments`"
                            class="text-sm font-semibold text-black break-words line-clamp-2 hover:underline cursor-pointer hover:text-blue-600"
                          >
                            {{ assignment.title }}
                          </router-link>
                          <p class="text-xs text-green-600">
                            <span class="font-medium">Status:</span>
                            {{ assignment.verify_status }}
                          </p>
                          <p class="text-xs text-gray-600">
                            <span class="font-medium">Course ID:</span>
                            {{ assignment.course_id }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Rejected Assignments Section -->
                <div
                  v-if="
                    taskList.rejected_assignments &&
                    taskList.rejected_assignments.length > 0
                  "
                >
                  <h2 class="text-sm font-bold text-red-600 mb-3">
                    Rejected Assignments
                  </h2>
                  <div class="flex flex-col gap-3">
                    <div
                      class="border-b pb-3 border-gray-300 last:border-b-0"
                      v-for="assignment in taskList.rejected_assignments"
                      :key="'rejected-' + assignment.id"
                    >
                      <div class="flex gap-3">
                        <img
                          src="@/assets/Group 610.png"
                          alt=""
                          class="object-contain w-6 h-6 mt-1 flex-shrink-0"
                        />
                        <div class="flex flex-col gap-1 flex-1 min-w-0">
                          <router-link
                            :to="`/student/dashboard/${assignment.course_id}/assignments`"
                            class="text-sm font-semibold text-black break-words line-clamp-2 hover:underline cursor-pointer hover:text-blue-600"
                          >
                            {{ assignment.title }}
                          </router-link>
                          <p class="text-xs text-red-600">
                            <span class="font-medium">Status:</span>
                            {{ assignment.verify_status }}
                          </p>
                          <p class="text-xs text-gray-600">
                            <span class="font-medium">Course ID:</span>
                            {{ assignment.course_id }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Calendar Events Section -->
                <div
                  v-if="
                    taskList.calendar_items &&
                    taskList.calendar_items.length > 0
                  "
                >
                  <h2 class="text-sm font-bold text-blue-600 mb-3">Events</h2>
                  <div class="flex flex-col gap-3">
                    <div
                      class="border-b pb-3 border-gray-300 last:border-b-0"
                      v-for="event in taskList.calendar_items"
                      :key="'event-' + event.id"
                    >
                      <div class="flex gap-3">
                        <img
                          src="@/assets/Group 610.png"
                          alt=""
                          class="object-contain w-6 h-6 mt-1 flex-shrink-0"
                        />
                        <div class="flex  justify-between items-center gap-1 flex-1 min-w-0">
                           <div class="flex flex-col gap-2">
                          <a
                            v-if="event.url"
                            :href="event.url"
                            target="blank"
                            class="text-sm hover:text-blue-600 font-semibold text-black break-words line-clamp-2 hover:underline cursor-pointer hover:text-blue-60"
                            >{{ event.title }}</a
                          >
                          <!-- <h3
                            class="text-sm font-semibold text-black break-words line-clamp-2 hover:underline cursor-pointer hover:text-blue-60"
                          >
                            {{ event.title }}
                          </h3> -->
                          <!-- Blue Right Arrow Icon SVG -->
                          
                          
                          <p
                            class="text-xs text-blue-600"
                            v-if="event.start_date"
                          >
                            Event Date: {{ formatDate(event.start_date) }}
                          </p>
                          </div>
                          <router-link
                            :to="`/student/dashboard/${event.course_data}/classes`"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4 text-blue-400 hover:text-blue-600 "
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Overdue Assignments Section -->
                <div
                  v-if="
                    taskList.overdue_assignments &&
                    taskList.overdue_assignments.length > 0
                  "
                >
                  <h2 class="text-sm font-bold text-orange-600 mb-3">
                    Overdue Assignments
                  </h2>
                  <div class="flex flex-col gap-3">
                    <div
                      class="border-b pb-3 border-gray-300 last:border-b-0"
                      v-for="assignment in taskList.overdue_assignments"
                      :key="'overdue-' + assignment.id"
                    >
                      <div class="flex gap-3">
                        <img
                          src="@/assets/Group 610.png"
                          alt=""
                          class="object-contain w-6 h-6 mt-1 flex-shrink-0"
                        />
                        <div class="flex flex-col gap-1 flex-1 min-w-0">
                          <router-link
                            :to="`/student/dashboard/${assignment.course_id}/assignments`"
                            class="text-sm font-semibold text-black break-words line-clamp-2 hover:underline cursor-pointer hover:text-blue-600"
                          >
                            {{ assignment.title }}
                          </router-link>
                          <p class="text-xs text-orange-600">
                            <span class="font-medium">Status:</span>
                            {{ assignment.verify_status }}
                          </p>
                          <p class="text-xs text-gray-600">
                            <span class="font-medium">Course ID:</span>
                            {{ assignment.course_id }}
                          </p>
                          <p
                            class="text-xs text-red-500"
                            v-if="assignment.due_date"
                          >
                            Due Date: {{ formatDate(assignment.due_date) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty state -->
              <div
                v-else
                class="flex items-center justify-center h-full text-gray-500"
              >
                No Announcements
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- My Learning -->
    <div class="pt-10 pb-20">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <div class="flex flex-row items-center justify-between px-5 lg:px-0">
            <p class="text-[#0F172A] text-3xl font-semibold">My Courses</p>
            <router-link
              :to="{ name: 'PreviewMyCourse' }"
              class="text-md text-[#0F172A] font-medium flex gap-1 items-center hover:text-indigo-600"
              >View All
              <img
                src="@/assets/newd/chevron-down(1).png"
                alt=""
                srcset=""
                class="w-4 h-4"
            /></router-link>
          </div>

          <div v-if="loading" class="flex items-center justify-center">
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div v-else class="mt-6 px-5 lg:px-0">
            <div v-if="this.courselist && this.courselist.course?.length">
              <div
                v-if="this.courselist"
                class="grid grid-cols-1 lg:grid-cols-3 gap-4"
              >
                <div
                  v-for="course in this.courselist.course.slice(0, 3)"
                  :key="course"
                  class="bg-white shadow-[0px_2px_30px_0px_rgba(1,0,0,0.1)] rounded-lg p-4 sm:p-6 h-auto"
                >
                  <div
                    @click="getDashboardOrPreviewUp(course.id)"
                    class="cursor-pointer"
                  >
                    <div class="relative flex justify-center items-center">
                      <img
                        v-if="course.thumbnail"
                        class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                        :src="course.thumbnail"
                        alt="Course Thumbnail"
                      />
                      <img
                        v-else
                        class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                        src="@/assets/coding.svg"
                        alt="Placeholder"
                      />
                    </div>
                    <div class="text-center flex flex-col gap-2 mt-2">
                      <p
                        class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate"
                      >
                        {{ course.title }}
                      </p>
                      <p class="text-xs sm:text-sm text-gray-600 text-left">
                        {{ course.section_count }} Module
                      </p>

                      <p
                        @click="getDashboardOrPreviewUp(course.id)"
                        class="mt-3 cursor-pointer py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] hover:bg-hover hover:text-white text-[#0F172A] font-medium text-center"
                      >
                        Continue Learning
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-lg font-normal text-center">
              No data Found
            </div>
          </div>
        </div>

        <!-- <div>
          <div class="flex flex-row items-center justify-between">
            <p class="text-[#0F172A] text-3xl font-semibold">
              Additional Courses
            </p>
            <router-link
              :to="{ name: 'StudentCommunity' }"
              class="text-md text-[#0F172A] font-medium flex gap-1 items-center"
              >View All
              <img
                src="@/assets/newd/chevron-down(1).png"
                alt=""
                srcset=""
                class="w-4 h-4"
            /></router-link>
          </div>
          <div v-if="loading" class="flex items-center justify-center">
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div v-else class="mt-6">
            <div v-if="this.courseDetails.length > 0">
              <div
                v-if="this.courseDetails[0]"
                class="grid grid-cols-1 gap-4 mt-6"
              >
                <div
                  v-for="course in this.courseDetails[0].course.slice(0, 3)"
                  :key="course"
                  class="bg-white shadow-[0px_2px_30px_0px_rgba(1,0,0,0.1)] rounded-lg p-4 sm:p-6 h-auto"
                >
                  <div
                    @click="getDashboardOrPreviewUp(course.id)"
                    class="cursor-pointer lg:flex lg:gap-5 w-full"
                  >
                    <div
                      class="relative flex justify-center items-center lg:w-[30%]"
                    >
                      <img
                        v-if="course.thumbnail"
                        class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                        :src="course.thumbnail"
                        alt="Course Thumbnail"
                      />
                      <img
                        v-else
                        class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                        src="@/assets/coding.svg"
                        alt="Placeholder"
                      />
                    </div>
                    <div
                      class="text-center flex flex-col lg:justify-between gap-2 mt-2 lg:w-[70%]"
                    >
                      <p
                        class="text-sm sm:text-base lg:text-lg text-gray-600 font-semibold text-left truncate"
                      >
                        {{ course.title }}
                      </p>
                      <p class="text-xs sm:text-sm text-gray-600 text-left">
                        {{ course.sections.length }} Units
                      </p>
                      <p
                        class="text-xs sm:text-sm text-gray-600 text-left line-clamp-2"
                      >
                        {{ course.short_description }}
                      </p>
                      <div class="lg:w-[400px] flex flex-col gap-2">
                        <div class="flex items-center justify-between w-full">
                          <div>
                            <p
                              class="text-sm"
                              v-if="course.completion_percentage < 100"
                            >
                              In progress
                            </p>
                            <p v-else class="text-sm">Complete</p>
                          </div>
                          <div>
                            <p class="text-sm">
                              {{ course.completion_percentage }}%
                            </p>
                          </div>
                        </div>

                        <div
                          class="relative w-full bg-gray-200 rounded-full h-4"
                        >
                          <div
                            class="absolute left-0 top-0 h-4 bg-blues rounded-full transition-all duration-300"
                            :style="{
                              width: course.completion_percentage + '%',
                            }"
                          ></div>
                        </div>
                      </div>
                      <p
                        @click="getDashboardOrPreviewUp(course.id)"
                        class="mt-3 cursor-pointer py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] lg:w-[200px] text-[#0F172A] font-medium text-center"
                      >
                        Continue Learning
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-lg font-normal text-center">
              No data Found
            </div>

           
          </div>
        </div> -->
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
// import FlashMessage from "@/components/flashMessage.vue";
import { mapGetters } from "vuex";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import Calendar from "@/components/Student_preview/Calendar.vue";

export default {
  name: "Home",
  data() {
    return {
      logotitle: process.env.VUE_APP_TITLE,
      courselist: [],
      blog_list: "",
      webinar_List: "",
      title: "",
      purchased_course: "",
      allyourcourse: "",
      listOfcourse: [],
      courseDetails: null,
      courseDetails: [],
      progress: 70,
      loading: true,
      notificationList: [],
      todolist: [],
      newTask: "",
      isEditing: false,
      editTaskText: "",
      editTaskId: null,
      showButton: false,
      editmessages: "",
      success_message: "",
      success_delemessage: "",
      currentYear: "",
      currentMonth: "",
      currentDate: "",
      fullDate: "",
      taskList: "",
      taskList: {
        accepted_assignments: [],
        rejected_assignments: [],
        calendar_items: [],
        overdue_assignments: [],
      },
      submitted: [],
      submittedURL: [],
    };
  },

  computed: {
     ...mapGetters("student", [
      "studentdata"]),

    hasAnnouncements() {
      const hasNotifications =
        this.notificationList && this.notificationList.length > 0;
      const hasAccepted = this.taskList?.accepted_assignments?.length > 0;
      const hasRejected = this.taskList?.rejected_assignments?.length > 0;
      const hasEvents = this.taskList?.calendar_items?.length > 0;
      const hasOverdue = this.taskList?.overdue_assignments?.length > 0;

      return (
        hasNotifications ||
        hasAccepted ||
        hasRejected ||
        hasEvents ||
        hasOverdue
      );
    },
  },

  components: {
    Header,
    Footer,
    // FlashMessage,
    VueCal,
    Calendar,
  },
  mounted() {
    this.getSubmittedURL();
    // setTimeout(() => {
    //   this.loading = false;
    // }, 2000);
    this.getNotifications();
    this.getTodo();
    this.getSubmittedData();
    this.title = process.env.VUE_APP_Title;
    if (!localStorage.getItem("previewIgnoreList")) {
      localStorage.setItem("previewIgnoreList", JSON.stringify([]));
    }
  },
  async created() {
    const today = new Date();
    this.currentDate = today.getDate();
    this.currentMonth = today.getMonth() + 1;
    this.currentYear = today.getFullYear();
    this.fullDate = `${this.currentYear}-${this.currentMonth}-${this.currentDate}`;
    console.log("currentDate", this.currentDate);
    console.log("currentMonth", this.currentMonth);
    console.log("currentYear", this.currentYear);
    console.log("fullDate", this.fullDate);

    await axios
      .get(
        `${process.env.VUE_APP_API}/student-buy-course-percentage/?Key=${this.studentdata.studentToken}`,
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.courseDetails = response.data.data;
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
    await axios
      .get(
        `${process.env.VUE_APP_API}/student-semester-get/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}&semester__id=${this.studentdata.semesterId}`,
      )
      .then((response) => {
        if (response.data.data.status == 200) {
          // this.courselist = response.data.data.data[0].semester[0];
          // console.log("this.courselist", this.courselist);
          const semesterData = response.data.data.data[0].semester[0];

          this.courselist = {
            ...semesterData,
            course: semesterData.course.filter(
              (course) => course.published_course?.published === true,
            ),
          };
        }
      });
  },
  methods: {
    getSubmittedURL() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course-external-links/list/?Key=${this.studentdata.studentToken}`,
        )
        .then((res) => {
          this.submittedURL = res.data.data || [];
        });
    },
    getShortName(url) {
      if (!url) return "";
      const fileName = url.split("/").pop();
      return fileName.length > 20
        ? fileName.substring(0, 20) + "..."
        : fileName;
    },

    getSubmittedData() {
      axios
        .get(
          `${process.env.VUE_APP_API}/pdf-upload-list/?Key=${this.studentdata.studentToken}`,
        )
        .then((res) => {
          this.submitted = res.data.data.data;
        });
    },
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };

      // Check if date string contains time information
      if (dateString.includes("T")) {
        return date.toLocaleDateString("en-US", options);
      } else {
        // Just date, no time
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      }
    },
    receiveCalEmit(data) {
      console.log("receive from the child", data);

      axios
        .get(
          `${process.env.VUE_APP_API}/today-status/?user_id=${this.studentdata.studentId}&Key=${this.studentdata.studentToken}&date=${data}`,
        )
        .then((res) => {
          this.taskList = res.data;
          console.log("Today status:", this.taskList);
        });

      axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}&date=${data}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
            console.log("this.todolist", this.todolist);
          }
        });

      axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}&date=${data}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
            console.log("this.notificationList", this.notificationList);
          }
        });

      // console.log(data, ":::date:::");
    },

    cleartask() {
      this.newTask = "";
      this.showButton = false;
    },
    getDashboardOrPreviewUp(id) {
      if (localStorage.getItem("previewIgnoreList")) {
        let preList = new Set(
          JSON.parse(localStorage.getItem("previewIgnoreList")),
        );

        if (preList.size != 0) {
          if (preList.has(id.toString())) {
            this.$router.push({
              name: "PreviewStudentCourseProgress",
              params: { course_id: id },
            });
          } else {
            this.$router.push({
              name: "PreviewStudentCourse",
              params: { course_id: id },
            });
          }
        } else {
          this.$router.push({
            name: "PreviewStudentCourse",
            params: { course_id: id },
          });
        }
      } else {
        this.$router.push({ name: "PreviewStudentCourse", params: { course_id: id } });
      }
    },
    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}&year=${this.currentYear}&month=${this.currentMonth}&date=${this.fullDate}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
            console.log(" this.notificationList", this.notificationList);
          }
        });
    },
    openEditPopup(task) {
      this.editTaskText = task.text;
      this.editTaskId = task.id;
      this.isEditing = true;
    },
    addTask() {
      if (this.newTask.trim()) {
        let bodyVal = {
          text: this.newTask,
          user: this.studentdata.studentId,
        };
        console.log("bodyVal", bodyVal);

        axios
          .post(
            `${process.env.VUE_APP_API}/to-do-create/?Key=${this.studentdata.studentToken}`,
            bodyVal,
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.success_message = response.data.message;
              setTimeout(() => {
                this.success_message = "";
              }, 900);
              this.newTask = "";
              this.showButton = false;
              this.getTodo();
            }
          })
          .finally(() => {
            this.loaders = false;
          });
      }
    },
    async getTodo() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}&search=false`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
            console.log(" this.todolist", this.todolist);
          }
        });
    },
    updateTask() {
      let formdata = {
        text: this.editTaskText,
      };
      console.log("formdata", formdata);

      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-text-edit/${this.editTaskId}/?Key=${this.studentdata.studentToken}`,
          formdata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.editmessages = response.data.message;

            setTimeout(() => {
              this.editmessages = "";
              this.isEditing = false;
              this.getTodo();
            }, 2000);
          }
        })
        .finally(() => {
          this.loaders = false;
        });
    },
    deleteTask(id) {
      console.log("sdafsdfsdfsd", id);
      axios
        .delete(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.studentdata.studentToken}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.success_delemessage = response.data.message;
            setTimeout(() => {
              this.success_delemessage = "";
            }, 900);
            this.getTodo();
          }
        });
    },
    completeTask(id) {
      let completedata = {
        completed: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.studentdata.studentToken}`,
          completedata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.success_message = response.data.message;
            setTimeout(() => {
              this.success_message = "";
            }, 900);
            this.getTodo();
          }
        });
    },
  },
};
</script>

<style></style>
